import { APICore } from "./apiCore";

const api = new APICore();

function getAllNotificationPreference(params: {
	pageNumber: number;
	pageSize: number;
	query: string;
}) {
	const baseUrl = "/api/NotificationPreference/GetAll";
	return api.get(`${baseUrl}`, params);
}

function getNotificationPreference(params: { id: number | string }) {
	const baseUrl = "/api/NotificationPreference/Get";
	return api.get(`${baseUrl}`, params);
}

function saveNotificationPreference(params: any) {
	const baseUrl = "/api/NotificationPreference/Save";
	return api.create(`${baseUrl}`, params);
}

function deleteNotificationPreference(id: string | number) {
	const baseUrl = "/api/NotificationPreference/Delete";
	return api.delete(`${baseUrl}?id=${id}`);
}

export { getAllNotificationPreference, getNotificationPreference, saveNotificationPreference, deleteNotificationPreference };